<template>
    <v-dialog
        v-model="displayDialog"
        max-width="575"
        :persistent="true"
    >
        <v-card v-if="displayDialog" light>
            <img src="static/img/Cross.svg" 
                style="float: right; height: 14px; margin: 15px;"
                class="cross-close" 
                @click="close"
            >
            <v-card-title>
                <h2 style="font-weight: normal; font-size: 24px;">
                    {{$t('instance.instance_list.modal_deploy.summary')}}
                </h2>
            </v-card-title>
            <v-card-text class="deployment-summary">
                <div class="deployment-item-container">
                    <h4>
                        {{$t('instance.instance_list.modal_deploy.application')}}
                    </h4>
                    <h4>{{ application.label }}</h4>
                </div>
                <div class="deployment-item-container">
                    <h4>
                        {{$t('instance.instance_list.modal_deploy.instance')}}
                    </h4>
                    <h4>{{ instance.label }}</h4>
                </div>
                <div class="deployment-item-container">
                    <h4>
                        {{$t('instance.instance_list.modal_deploy.current_datamodel')}}
                    </h4>
                    <h4> {{$t('instance.instance_list.modal_deploy.version')}} {{ instance.current_modelisation.version }}</h4>
                </div>
                <div class="deployment-item-container">
                    <h4>
                        {{$t('instance.instance_list.modal_deploy.target_title')}}
                    </h4>
                    <v-select
                        v-model="targetModelisation"
                        :items="modelisations"
                        :item-text="verboseVersion"
                        item-value="uid"
                        :label="$t('instance.instance_list.modal_deploy.select_label')"
                    ></v-select>
                </div>

            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
                <v-row justify="end" class="dialog-confirm-buttons">
                    <v-col cols="3">
                        <v-btn
                            @click="displayDialog = false"
                        >
                            {{$t('instance.instance_list.modal_deploy.btn_close')}}
                        </v-btn>
                    </v-col>
                    <v-col cols="6">
                        <v-btn
                            color="info"
                            @click="deploy"
                        >
                            {{$t('instance.instance_list.modal_deploy.confirm_deploy')}}
                        </v-btn>
                    </v-col>
                </v-row>
            </v-card-actions>
        </v-card>

    </v-dialog>
</template>

<script>

export default {

    components: {

    },

    props: {

    },

    data (){
        return {
            displayDialog: false,
            modelisations: null,
            targetModelisation: '',
            application: null,
            instance: null,
        };
    },

    computed: {

    },

    mounted (){

    },

    methods: {
        deploy (){
            this.$emit('deploy', this.targetModelisation);
        },

        init (application, instance, modelisations){
            this.$set(this, 'application', application);
            this.$set(this, 'instance', instance);
            this.$set(this, 'modelisations', modelisations);
            this.targetModelisation = modelisations.sort((a,b) => {
                return a.version - b.version;
            }).reverse()[0].uid;
            this.displayDialog = true;
        },

        verboseVersion (modelisation){
            return `v${modelisation.version}`;
        },
        close (){
            this.displayDialog = false;
        }
    },
};
</script>

<style lang="scss">
.cross-close:hover{
    cursor: pointer;
}
.deployment-summary{
    .deployment-item-container{
        display: flex;
        align-items: center;
    }
    h4:nth-child(2n+0){
        font-weight: 500;
    }
    h4{
        font-weight: normal;
        flex-basis: 50%;
        margin-bottom: 15px;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/page/Instance/InstanceList/modal-deploy.vue